import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { TranslateService } from '@ngstack/translate';
import { ErrorsService } from 'src/app/services/common/errors.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { AccountService } from 'src/app/services/http/business/account/account.service';
import { SnackBarService } from 'src/app/services/common/snackBar.service';
import { SoundEnum } from 'src/app/enums/sound.enum';
import { IDiscountgGroup } from 'src/app/interfaces/discount-group';
import { CourseService } from 'src/app/services/http/business/course/course.service';
import { IError } from 'src/app/interfaces/error.interface';

@Component({
  selector: 'app-add-supervisor-to-virtual-course',
  templateUrl: './add-supervisor-to-virtual-course.component.html',
  styleUrls: ['./add-supervisor-to-virtual-course.component.css']
})
export class AddSupervisorToVirtualCourseComponent implements OnInit {

  form: FormGroup;

  param: any;
  errorList: IError[] = [];
  errObject: any;
  errors = new Array();
  nationalCode: any;
  showSubmit: boolean;
  discountList: IDiscountgGroup[] = [];
  userInfo: any;
  showTable: boolean;
  personDiscountGroup: string;
  discountGroupList = [];
  showDiscount = false;

  constructor(
    private fb: FormBuilder,
    public translate: TranslateService,
    private snackBar: SnackBarService,
    private errorService: ErrorsService,
    private courseService: CourseService,
    private accountService: AccountService,
    private dialogRef: MatDialogRef<AddSupervisorToVirtualCourseComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }
  ngOnInit() {
    this.createForm()
  }

  createForm() {
    this.form = this.fb.group({
      SearchNationalCode: [
        null,
        Validators.compose([Validators.required, Validators.pattern("^[0-9]*$"),
        Validators.minLength(10),
        Validators.maxLength(12)])
      ],
      NationalCode: [
        null,
        Validators.compose([Validators.required, Validators.pattern("^[0-9]*$"),
        Validators.minLength(10),
        Validators.maxLength(12)])
      ],
      CourseId: [this.data.CourseId],
    });
  }

  getUserInfo(data: any) {
    this.errors = new Array();
    this.accountService.getSimpleUserInfo(data.SearchNationalCode).subscribe(
      res => {
        this.form.controls['NationalCode'].setValue(data.SearchNationalCode)
        this.showSubmit = true;
        this.userInfo = res.FullName;
        this.showTable = false;
      },
      err => {
        // this.errObject = this.errorService.getError(err);
        // this.param = this.errorService.objectError(this.errObject);
        // this.errors = this.errorService.returnError(err);
        this.errorList = this.errorService.getErrorList(err.error);
      }
    );
  }


  submit(data: any) {
    this.errors = new Array();
    let model = {
      NationalCode: data.NationalCode,
      CourseId: data.CourseId,
    }
    this.courseService.addSupervisorToVirtualCourse(model).subscribe(res => {
      console.log(res);
      this.snackBar.OpenSnackBar(
        'ناظر با موفقیت به جلسات مجازی اضافه شد',
        "ok",
        5000,
        SoundEnum.beep
      );
      this.dialogRef.close();
    }, err => {
      // this.errObject = this.errorService.getError(err);
      // this.param = this.errorService.objectError(this.errObject);
      // this.errors = this.errorService.returnError(err);
      this.errorList = this.errorService.getErrorList(err.error);
    })
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

}
